/* eslint-disable max-classes-per-file */
import { Money, Uuid } from '@ftr/contracts/type/shared'

export class FetchCustomerOrderAction {
  static readonly type = '[Order] Fetch Customer Order'
  constructor(
    public orderId: Uuid,
    public orderIsShared = false,
  ) {}
}

export class ResetOrderStateAction {
  static readonly type = '[Order] Reset Order State'
}

export class SetRealTimeOrderUsageFeeAction {
  static readonly type = '[Order] Set RealTime Order Usage Fee'
  constructor(public usageFee: Money | undefined) {}
}

export class SetRealTimeOrderEligibleToRejoinAction {
  static readonly type = '[Order] Set RealTime Order eligibleToRejoin state'
  constructor(public eligibleToRejoin: boolean) {}
}

export class SetRealTimeOrderIsInProgressAction {
  static readonly type = '[Order] Set RealTime Order isInProgress state'
  constructor(public isInProgress: boolean) {}
}

export class StartRealTimeOrderAction {
  static readonly type = '[Order] Start RealTime Order'
  constructor(public userPlacedOrder: boolean) {}
}

export class ResetRealTimeOrderAction {
  static readonly type = '[Order] Reset RealTime Order'
}

export class RequestToStopRealTimeOrderAction {
  static readonly type = '[Order] Request To Stop RealTime Order'
  constructor(public requestedToStop: boolean) {}
}

export class RequestToRejoinRealTimeOrderAction {
  static readonly type = '[Order] Request To Rejoin RealTime Order'
  constructor(public requestedToRejoin: boolean) {}
}
